import type { WalletClient } from "../../../libs/client";
import type { TenantWithFeature } from "../../../libs/connect";
import { AppError, ERROR_CODES } from "../../../libs/errors";

export type InvitationStatus = {
  isInvitationCampaignOver: boolean;
};

export async function getInvitationStatus({
  tenant,
  client,
}: {
  tenant: TenantWithFeature;
  client: WalletClient;
}): Promise<InvitationStatus> {
  // 友だち紹介機能が無効な場合
  if (!tenant.feature.invitation) {
    return {
      isInvitationCampaignOver: false,
    };
  }

  // 友だち紹介情報を取得（プライマリキャンペーン応募状態に関係なく）
  const invitationResponse = await client.getMyInvitation({}).catch((error) => {
    throw new AppError(
      ERROR_CODES.CONNECT_GET_MY_INVITATION_FAILED,
      error.message,
      {
        originalError: error,
      },
    );
  });

  // キャンペーン終了判定
  const isInvitationCampaignOver = invitationResponse.isCampaignOver;

  return {
    isInvitationCampaignOver,
  };
}
